import React from 'react';
import { Modal, Button } from 'react-bootstrap';

const ErrorModal = ({ errorMessage, onClose, excelData }) => {
  const errorData = React.useMemo(() => {
    try {
      return typeof errorMessage === 'string'
        ? JSON.parse(errorMessage)
        : errorMessage || {};
    } catch (e) {
      return {
        message: 'Invalid error data format',
        'Not uploaded': []
      };
    }
  }, [errorMessage]);

  const errorRowNumbers = React.useMemo(() => (
    errorData['Not uploaded']?.map(item => item.row_number) || []
  ), [errorData]);

  return (
    <Modal show={true} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Upload Errors</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="alert alert-danger">
          {errorData.message || 'There were errors in your upload'}
        </div>

        {/* {errorData['Not uploaded']?.length > 0 && (
          <div className="error-summary">
            <h5>Error Summary:</h5>
            <ul>
              {errorData['Not uploaded'].map((item, index) => (
                <li key={index}>
                  Row {item.row_number}: {Object.values(item.errors || {}).join(', ')}
                </li>
              ))}
            </ul>
          </div>
        )} */}

        {excelData?.headers && errorRowNumbers.length > 0 && (
          <div className="error-table-container">
            <h5>Rows with Errors:</h5>
            <div className="table-responsive">
              <table className="table table-bordered table-sm">
                <thead>
                  <tr>
                    <th>Excel Row #</th>
                    {excelData.headers.map((header, index) => (
                      <th key={index}>{header}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {errorRowNumbers.map((rowNumber) => {
                    const dataIndex = rowNumber - 1;
                    const row = excelData.data[dataIndex];

                    if (!row) return null;

                    const rowErrors = errorData['Not uploaded'].find(
                      err => err.row_number === rowNumber
                    )?.errors || {};

                    return (
                      <tr key={rowNumber} className="error-row">
                        <td>{rowNumber}</td>
                        {row.map((cell, cellIndex) => {
                          const headerName = excelData.headers[cellIndex];
                          const errorMessage = rowErrors[headerName];

                          return (
                            <td
                              key={cellIndex}
                              style={errorMessage ? {
                                backgroundColor: '#ffebee',
                                color: '#d32f2f',
                                fontWeight: 'bold'
                              } : {}}
                              title={errorMessage || ''}
                            >
                              {cell}
                              {errorMessage && (
                                <div className="error-tooltip">{errorMessage}</div>
                              )}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ErrorModal;